import { PaymentElement } from '@stripe/react-stripe-js';
import type { StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import React from 'react';

type CardFormProps = {
  onComplete?: (complete: boolean) => void;
};

export const CardForm = ({ onComplete }: CardFormProps) => {
  const handleChange = (event: StripePaymentElementChangeEvent) => {
    onComplete?.(event.complete);
  };

  return (
    <div style={{ width: '100%' }}>
      <PaymentElement
        options={{
          layout: {
            type: 'tabs',
          },
        }}
        onChange={handleChange}
      />
    </div>
  );
};
